// import { push } from 'react-router-redux';
// import gaPush, { gaSetUser } from '../globs/utils/google-analytics';


export default function clearFilter() {

  return (dispatch) => {
    dispatch(clear());
  };
}

function clear() {
    return {
      type: 'clearFilter',
      payload: {},
    };
  }